var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1249 2.87523C13.3992 5.15484 13.3992 8.8452 11.1249 11.1248C8.84681 13.4029 5.15335 13.4029 2.87529 11.1248C0.597233 8.84675 0.597233 5.15329 2.87529 2.87523C5.15335 0.597172 8.84681 0.597172 11.1249 2.87523ZM9.47495 4.52515C9.26342 4.31361 8.92984 4.2985 8.70088 4.47982L8.65 4.52515L7.00008 6.17506L5.35017 4.52515C5.12236 4.29734 4.75301 4.29734 4.52521 4.52515C4.31367 4.73668 4.29856 5.07026 4.47988 5.29923L4.52521 5.3501L6.17512 7.00002L4.52521 8.64994C4.2974 8.87774 4.2974 9.24709 4.52521 9.47489C4.73674 9.68643 5.07032 9.70154 5.29929 9.52022L5.35017 9.47489L7.00008 7.82498L8.65 9.47489C8.8778 9.7027 9.24715 9.7027 9.47495 9.47489C9.68649 9.26336 9.7016 8.92978 9.52028 8.70082L9.47495 8.64994L7.82504 7.00002L9.47495 5.3501C9.70276 5.1223 9.70276 4.75295 9.47495 4.52515Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.51127f4b.svg";
export { ForwardRef as ReactComponent };